import React from 'react'
import Nav from "./Nav"
function Header() {
  return (
    <>
    <div className='bg-dark'>
        <div className='container'>
        <div className='row'>
        <div className='col-lg-6'>
            <ul className='left d-flex mb-0 fw-normal'>
                <li> <i class="bi bi-phone px-3 border-end lh-lg"></i></li>
                <li><p className='mb-0 ps-2 pe-3'> 983 592 88 52</p></li>
                <li> <i class="bi bi-envelope px-3 border-end lh-lg"></i></li>
                <li><a href='#'><p className='mb-0 ps-3'>mail@domain.com</p></a></li>
            </ul>
        </div> 
        <div className='col-lg-6'>
            <ul className='left d-flex mb-0 fw-normal float-end'>
            <li><a href='#'><i class="bi bi-facebook px-3 lh-lg"></i></a></li>
            <li><a href='#'><i class="bi bi-twitter px-3 lh-lg"></i></a></li>
            <li><a href='#'><i class="bi bi-google px-3 lh-lg"></i></a></li>
            <li><a href='#'><i class="bi bi-pinterest px-3 lh-lg"></i></a></li>
            <li><a href='#'><i class="bi bi-instagram border-end px-3"></i></a></li>
            <li><p className='pb-0 mb-0 ps-2'>Thousday July 4 , 2017</p></li>
            </ul>
        </div>
      </div>
        </div>
    </div>
    <div className='container'>
        <div className='row'>
            <div className='col-lg-4 py-3'>
                <img width={250} src={require('../image/logo.jpg')}/>
            </div>
            <div className='col-lg-8 py-1 pe-0'>
                <img className='w-100' src={require('../image/banner.jpg')}/>
            </div>
        </div>
    </div>
    <Nav/> 
    </>
  )
}

export default Header
